<template>
  <div
    ref="mainElement"
    class="simulation-progressbar-segment"
    :class="{
      'is-current': isCurrent,
      'has-focus': state.hasFocus
    }"
  >
    <button
      class="simulation-progressbar-segment__label"
      type="button"
      :disabled="!isPlayedOrPlayable"
      @click="goToRound()"
      @focus="state.hasFocus = true"
      @blur="state.hasFocus = false"
    >
      {{ roundIndex + 1 }}
    </button>
    <round-actions
      :simulation-id="simulationId"
      :round-index="roundIndex"
      :width="width"
      :max-height="contentHeight"
      :hide-invisibles="hideInvisibles"
    />
  </div>
</template>

<script setup lang="ts">
/**
 * This is one round in the player progress bar.
 */
import { reactive, computed, useTemplateRef } from "vue";

import { useSimulationViewStore } from "@editor/views/simulation/simulationView.store";

import RoundActions from "@editor/items/simulationRound/RoundActions.vue";

interface Props {
  simulationId: number;
  roundIndex: number;
  active?: boolean;
  width?: number;
  contentHeight?: number;
  hideInvisibles?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  active: false,
  width: 100,
  contentHeight: undefined,
  hideInvisibles: false
});

const mainElement = useTemplateRef("mainElement");

const simulationViewStore = useSimulationViewStore();

const state = reactive({
  hasFocus: false
});

const isPlayedOrPlayable = computed(() => {
  return props.roundIndex <= simulationViewStore.currentRoundIndex;
});

const isCurrent = computed(() => {
  const selectedRound = simulationViewStore.selectedRound;
  if (selectedRound == null) return false;
  return props.roundIndex === selectedRound.index;
});

function goToRound() {
  useSimulationViewStore().goToRound(props.roundIndex);
}

defineExpose({
  mainElement
});
</script>

<style lang="scss">
.simulation-progressbar-segment {
  width: 100%;
  position: relative;

  &__label {
    padding-top: 1rem;
    width: 100%;
    background-color: transparent;
    border: none;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    &:focus {
      outline: none;
    }
    .is-selected & {
      color: var(--color-action);
      font-weight: 700;
    }
    &:disabled {
      color: var(--color-text-light);
    }
  }
}
</style>
